import angular from 'angular';
import pageHeaderComponent from './page-header.component';


let pageHeaderModule = angular.module('pageHeader', [

])

.component('pageHeader', pageHeaderComponent);

export default pageHeaderModule;



// WEBPACK FOOTER //
// ./client/common/page-header/page-header.js